import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { PREVIOUS_LOCATION } from '../../../constants/localStorageKeys';
import { SIGNIN_PATH } from '../../../constants/pathRedirect';

export function ConnectNetSuiteWarehouseRedirect() {
  const { supplierId } = useSelector((state) => state.role);

  if (supplierId) {
    return <Redirect to={`/suppliers/${supplierId}/warehouses/net-suite`} />;
  }

  sessionStorage.setItem(PREVIOUS_LOCATION, '/suppliers/warehouses/net-suite');
  return <Redirect to={SIGNIN_PATH} />;
}
